var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.64,85.5H22.36A6.36,6.36,0,0,1,16,79.15V19.89a6.36,6.36,0,0,1,6.36-6.35h8.06a2.5,2.5,0,0,1,.4,0H65.71A14.45,14.45,0,0,1,74.5,17l9.71,9A13.11,13.11,0,0,1,88,34.64v44.5A6.36,6.36,0,0,1,81.64,85.5Zm-2.47-4.24h2.47a2.12,2.12,0,0,0,2.12-2.12V34.64a9,9,0,0,0-2.43-5.58l-9.71-9a10.41,10.41,0,0,0-5.91-2.31H64.34a6.16,6.16,0,0,1,.37,2.11V34.68A6.36,6.36,0,0,1,58.35,41H30.82a6.36,6.36,0,0,1-6.35-6.35V19.85a6.27,6.27,0,0,1,.36-2.08H22.36a2.12,2.12,0,0,0-2.12,2.12V79.15a2.12,2.12,0,0,0,2.12,2.11h2.47a6.4,6.4,0,0,1-.36-2.11V53.74a6.36,6.36,0,0,1,6.35-6.36H73.18a6.36,6.36,0,0,1,6.35,6.36V79.15A6.4,6.4,0,0,1,79.17,81.26Zm-48.35,0H73.18a2.12,2.12,0,0,0,2.11-2.11V53.74a2.12,2.12,0,0,0-2.11-2.12H30.82a2.12,2.12,0,0,0-2.11,2.12V79.15A2.12,2.12,0,0,0,30.82,81.26Zm-.2-63.5a2.11,2.11,0,0,0-1.91,2.09V34.68a2.12,2.12,0,0,0,2.11,2.11H58.35a2.12,2.12,0,0,0,2.12-2.11V19.85a2.13,2.13,0,0,0-2.06-2.11ZM54.05,29.67h2.71V23.23H54.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.75cdf01569671dd4e81bf34675cfe5f9.svg";
export { ForwardRef as ReactComponent };